export enum DbSchemeEnum {
  Dert = "dert",
}
